import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themetwo/icon-search.png'


const _hoisted_1 = { class: "searchField" }
const _hoisted_2 = { class: "gameContainer" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}

import { ref, computed, watch, inject } from 'vue';
import GamePopup from '../../game/gamePopup.vue';
import { debounce, fetchGameList, goToPlayGame } from '@/view/home/supportScript';
import { useRouter } from 'vue-router';
const PAGE_SIZE = 20

export default /*@__PURE__*/_defineComponent({
  __name: 'gameSearchPopup',
  setup(__props, { expose: __expose }) {

const router = useRouter()
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const show = ref(false)
const localValue = ref('')
const openPopup = () => {
    show.value = true;
    getGameList()
}
const gameListRef = ref()
const gameList = ref<any>([])
const gameCount = ref(0)
const pageNum = ref(1)
const loading = ref(false)
const pageSize = ref(PAGE_SIZE)
const showLoadMore = ref(false)
const gamesLoading = ref(false)
const mainHeader = ref<{ url: string; display: boolean }>({ url: '', display: true })
const depositButon = ref({
    colorCode: '',
    display: false,
    redirectUrl: ''
})
const profileButtonData = ref({
    url: '',
    display: false,
    redirectUrl: ''
})
const gameSet = computed(() => ({
    gameCount: gameCount.value,
    gameList: gameList.value,
    showLoadMore: showLoadMore.value,
    loading: loading.value,
    //-------------------
    show: false,
    showPopover: false,
    groupList: [],
    activeItem: 0,
    balance: 0,
    mainHeader: mainHeader.value,
    depositButon: depositButon.value,
    profileButtonData: profileButtonData.value,
}))
const closePopup = () => {
    show.value = false;
}

const clickShowMore = () => {
    if (gameCount.value > pageNum.value * pageSize.value) {
        pageNum.value = pageNum.value + 1
        getGameList()
    }
}

const getGameList = async () => {
    loading.value = true
    gamesLoading.value = true
    const { rows, total } = await fetchGameList(pageNum.value, pageSize.value, localValue.value)

    loading.value = false
    gamesLoading.value = false
    gameList.value = [...gameList.value, ...rows]
    gameCount.value = total
    showLoadMore.value = total > pageNum.value * pageSize.value
}
const GoToPlayGame = (data: any) => {
    goToPlayGame(router, openRegisterLoginPopup, data.id, data.makerId, data.isFavorite, data.favId)
}
const resetList = () => {
    pageNum.value = 1;
    gameList.value = [];
};
const debouncedSearch = debounce(() => {
    resetList()
    getGameList()
}, 500)

watch(localValue, () => {
    debouncedSearch()
})
__expose({
    openPopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    onClickOverlay: closePopup,
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    position: "center",
    style: { height: '80%',zIndex:'10002' },
    class: "gamePopContainer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, { class: "popHeader" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "20",
            offset: "2",
            class: "Poptitle"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('home.allGames')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "2" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "cross",
                size: "16",
                onClick: closePopup
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_field, {
          modelValue: localValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
          type: "text",
          placeholder: _ctx.$t('home.searchGames'),
          class: "custom-field"
        }, {
          "left-icon": _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "left-section" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)
          ])),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(GamePopup, {
          "data-set": gameSet.value,
          onLoadMoreGame: clickShowMore,
          ref_key: "gameListRef",
          ref: gameListRef,
          onGoToPlayGame: GoToPlayGame
        }, null, 8, ["data-set"]),
        (gamesLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_van_loading, {
                type: "spinner",
                size: "60"
              })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})